import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress
} from "@mui/material";

const WeightageTopNDialog = ({
  open,
  onClose,
  weightage,
  setWeightage,
  topNValue,
  setTopNValue,
  weightageError,
  validateWeightage,
  dialogLoading,
  onSubmit
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Weightage Percentage</DialogTitle>

      <DialogContent>
        <div style={{ marginBottom: 16 }}>
          <h4>Weighted Average (%)</h4>

          <TextField
            label="Volume (%)"
            type="number"
            fullWidth
            margin="dense"
            value={weightage.Volume}
            onChange={(e) => {
              const updated = {
                ...weightage,
                Volume: e.target.value
              };
              setWeightage(updated);
              validateWeightage(updated);
            }}
          />

          <TextField
            label="Value (%)"
            type="number"
            fullWidth
            margin="dense"
            value={weightage.Value}
            onChange={(e) => {
              const updated = {
                ...weightage,
                Value: e.target.value
              };
              setWeightage(updated);
              validateWeightage(updated);
            }}
          />
        </div>

        {weightageError && (
          <div style={{ color: "red", fontSize: 12 }}>
            {weightageError}
          </div>
        )}

        <hr />

        <div>
          <h4>Top N Configuration</h4>

          <TextField
            label="Top N Value"
            type="number"
            fullWidth
            margin="dense"
            value={topNValue}
            onChange={(e) => {
              const value = e.target.value;
              setTopNValue(value);
              validateWeightage(weightage, value);
            }}
            slotProps={{
              htmlInput: {
                min: 1
              }
            }}
          />
        </div>

        {dialogLoading && (
          <div style={{ textAlign: "center", marginTop: 10 }}>
            <CircularProgress size={22} />
            <div style={{ fontSize: 12 }}>
              Updating configuration...
            </div>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            color: "#3447d4",
            textTransform: "none"
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={!!weightageError || dialogLoading}
          sx={{
            backgroundColor: "#3447d4",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#2b3bb3"
            },
            "&.Mui-disabled": {
              backgroundColor: "#aab2f5",
              color: "#ffffff"
            }
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

WeightageTopNDialog.propTypes = {
  open: PropTypes.bool.isRequired,

  onClose: PropTypes.func.isRequired,

  weightage: PropTypes.shape({
    Volume: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    Value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired
  }).isRequired,

  setWeightage: PropTypes.func.isRequired,

  topNValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,

  setTopNValue: PropTypes.func.isRequired,

  weightageError: PropTypes.string,

  validateWeightage: PropTypes.func.isRequired,

  dialogLoading: PropTypes.bool.isRequired,

  onSubmit: PropTypes.func.isRequired
};

WeightageTopNDialog.defaultProps = {
  weightageError: ""
};

export default WeightageTopNDialog;